// Pages
import RouterView from '@/components/pages/RouterView/Router'

import Users from '@/components/pages/Users/Users.vue'
import User from '@/components/pages/Users/User.vue'
import AddUser from '@/components/pages/Users/AddUser.vue'
import EditUser from '@/components/pages/Users/EditUser.vue'
import Activation from '@/components/pages/Users/Activation.vue'

export default {
  path: '/users',
  component: RouterView,
  meta: {requiresAuth: true},
  children: [
    {
      path: '',
      name: 'all-users',
      component: Users,
      meta: {breadcrumb: 'Users'},
      beforeEnter: (to, from, next) => {
        if(!to.params.sideNav) {
          if(from.name === 'view-surgeon' || from.name === 'edit-surgeon') {
            to.params.role = 'surgeon'
          }
          if(from.name === 'view-nurse' || from.name === 'edit-nurse') {
            to.params.role = 'nurse'
          }
          if(from.name === 'view-admin' || from.name === 'edit-admin') {
            to.params.role = 'raypro_admin'
          }
          if(from.name === 'view-distributor' || from.name === 'edit-distributor') {
            to.params.role = 'rayner_distributor'
          }
        }
        next()
      }
    },
    {
      path: 'add-user',
      component: AddUser,
      meta: {breadcrumb: 'Add New User'}
    },
    {
      path: 'activation',
      component: Activation,
      meta: {breadcrumb: 'Users Activation'}
    },
    {
      path: ':id',
      component: RouterView,
      props: true,
      children: [
        {
          path: '',
          component: User,
          props: true,
          name: 'view-user'
        },
        {
          path: 'edit',
          component: EditUser,
          name: 'edit-user',
          meta: {breadcrumb: 'Edit'}
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/users.js